// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .hb-button {
  padding: 7px 28px;
  display: inline-block;
  text-align: center;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
  will-change: color, transform;
  outline-offset: 3px;
  transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;
}
app-root .hb-button.primary-button {
  outline-color: black;
  border: none;
  background-color: #8c1c16;
  color: white;
}
app-root .hb-button.primary-button:active {
  transform: scale(0.95);
}
app-root .hb-button.primary-button:hover {
  background-color: #c52820;
}
app-root .hb-button.primary-button:disabled {
  background-color: var(--background-grey);
  border-color: var(--outline-grey);
  color: var(--outline-grey);
}
app-root .hb-button.secondary-button {
  color: var(--border-grey);
  padding-top: 6px;
  padding-bottom: 6px;
  outline-offset: 4px;
  border: 1px solid var(--border-grey);
  text-decoration: none;
}
app-root .hb-button.secondary-button:active {
  transform: scale(0.95);
}
app-root .hb-button.secondary-button:visited {
  color: var(--border-grey);
}
app-root .hb-button.secondary-button:hover {
  color: var(--primary);
}
app-root .hb-button.secondary-button:disabled {
  background-color: var(--background-grey);
  border-color: var(--outline-grey);
  color: var(--outline-grey);
  transform: none;
}
app-root .hb-button.button-small {
  padding: 2px 24px;
}
app-root .button-wrapper {
  margin: 0 auto;
  max-width: 792px;
}
@media (min-width: 900px) {
  app-root .button-wrapper {
    width: calc(9 * (100% - 176px) / 12 + 128px);
  }
}
@media (min-width: 1151px) {
  app-root .button-wrapper {
    width: calc(6 * (100% - 176px) / 12 + 80px);
  }
}
app-root .form-nav {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
app-root .lf-flow.loaded .form-nav {
  margin: 0 -16px;
  left: 16px;
  width: 100%;
  min-width: 320px;
  position: fixed;
}
@media (min-width: 1151px) {
  app-root .lf-flow.loaded .form-nav {
    width: 66%;
  }
}
app-root .lf-flow.loaded .button-wrapper {
  margin: 0 auto;
  max-width: 792px;
}
@media (min-width: 900px) {
  app-root .lf-flow.loaded .button-wrapper {
    width: calc(9 * (100% - 176px) / 12 + 128px);
  }
}
@media (min-width: 1151px) {
  app-root .lf-flow.loaded .button-wrapper {
    width: calc(6 * (100% - 176px) / 12 + 80px);
  }
}
@media (min-width: 1151px) {
  app-root .lf-flow.loaded .button-wrapper {
    width: calc(6 * (100% - 112px) / 8 + 80px);
  }
}
@media (min-width: 1350px) {
  app-root .lf-flow.loaded .button-wrapper {
    width: calc(8 * (100% - 144px) / 10 + 112px);
  }
}
@media (min-width: 1500px) {
  app-root .lf-flow.loaded .button-wrapper {
    width: calc(6 * (100% - 144px) / 10 + 80px);
  }
}
app-root .form-nav {
  left: 16px;
  bottom: 0;
  padding: 16px;
  font-size: 1rem;
  background-color: white;
  border-top: 1px solid var(--header-border);
  z-index: 10;
}
app-root .form-nav .button-wrapper:after {
  content: '';
  display: table;
  clear: both;
}
app-root .form-nav .button-wrapper li {
  display: inline-block;
}
app-root .form-nav .button-wrapper li:first-of-type {
  float: right;
  margin-left: 16px;
}
app-root .form-nav .button-wrapper li:last-of-type {
  float: left;
}
app-root .form-nav .button-wrapper .hb-button {
  width: 136px;
}
app-root .form-nav .button-wrapper .hb-button .primary-button:hover {
  background-color: #705d5c;
}
app-root .form-nav .button-wrapper .hb-button .primary-button:active {
  transform: scale(0.99);
}
app-root .form-nav .button-wrapper .hb-button .primary-button.permitted:active {
  transform: scale(0.95);
}
app-root .form-nav .button-wrapper .hb-button .primary-button.permitted:hover {
  background-color: #c52820;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Components/Form/Nav/Nav.less","webpack://./src/Styles/buttons.less","webpack://./src/Styles/GridLayout/layoutHelpers.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACRA;EAEI,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,yEAAA;ADSJ;ACPI;EACE,oBAAA;EACA,YAAA;EAGA,yBAAA;EACA,YAAA;ADON;ACNM;EACE,sBAAA;ADQR;ACLM;EACE,yBAAA;ADOR;ACJM;EACE,wCAAA;EACA,iCAAA;EACA,0BAAA;ADMR;ACHI;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;ADKN;ACHM;EACE,sBAAA;ADKR;ACFM;EACE,yBAAA;ADIR;ACDM;EACE,qBAAA;ADGR;ACAM;EACE,wCAAA;EACA,iCAAA;EACA,0BAAA;EACA,eAAA;ADER;ACEI;EACE,iBAAA;ADAN;AA5DA;EEiBE,cAAA;EACA,gBAAA;AF8CF;AE5CE;EAAA;IAXA,4CAAA;EF2DA;AACF;AE1CE;EAAA;IAlBA,2CAAA;EFgEA;AACF;AA1EA;ED+BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AC8CF;AAjFA;ED+BE,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ACqDF;ADjBE;EAAA;IACE,UAAA;ECoBF;AACF;AA7FA;EEiBE,cAAA;EACA,gBAAA;AF+EF;AE7EE;EAAA;IAXA,4CAAA;EF4FA;AACF;AE3EE;EAAA;IAlBA,2CAAA;EFiGA;AACF;AD1DE;EAAA;IGxCA,0CAAA;EFsGA;AACF;AD5DE;EAAA;IG3CA,4CAAA;EF2GA;AACF;AD9DE;EAAA;IG9CA,2CAAA;EFgHA;AACF;AA1HA;EAiBI,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,0CAAA;EACA,WAAA;AA4GJ;AAzGM;EACE,WAAA;EACA,cAAA;EACA,WAAA;AA2GR;AAxIA;EAiCQ,qBAAA;AA0GR;AAxGQ;EACE,YAAA;EACA,iBAAA;AA0GV;AAvGQ;EACE,WAAA;AAyGV;AAlJA;EA8CQ,YAAA;AAuGR;AApGU;EACE,yBAAA;AAsGZ;AAnGU;EACE,sBAAA;AAqGZ;AAjGY;EACE,sBAAA;AAmGd;AAhGY;EACE,yBAAA;AAkGd","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../Styles/utilities.less';\n@import '../../../Styles/buttons.less';\n\napp-root {\n  .button-wrapper {\n    .wide-content();\n  }\n  .form-nav {\n    .fixed-full-width-content();\n  }\n\n  .lf-flow.loaded {\n    .form-nav {\n      .fixed-two-third-width-content();\n    }\n    .button-wrapper {\n      .wide-leadfeed-content();\n    }\n  }\n  .form-nav {\n    left: @body-gutter-width;\n    bottom: 0;\n    padding: @body-gutter-width;\n    font-size: 1rem;\n    background-color: white;\n    border-top: 1px solid var(--header-border);\n    z-index: 10;\n\n    .button-wrapper {\n      &:after {\n        content: '';\n        display: table;\n        clear: both;\n      }\n\n      li {\n        display: inline-block;\n\n        &:first-of-type {\n          float: right;\n          margin-left: 16px;\n        }\n\n        &:last-of-type {\n          float: left;\n        }\n      }\n\n      .hb-button {\n        width: 136px;\n\n        .primary-button {\n          &:hover {\n            background-color: #705d5c;\n          }\n\n          &:active {\n            transform: scale(0.99);\n          }\n\n          &.permitted {\n            &:active {\n              transform: scale(0.95);\n            }\n\n            &:hover {\n              background-color: #c52820;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","app-root {\n  .hb-button {\n    padding: 7px 28px;\n    display: inline-block;\n    text-align: center;\n    font-weight: 600;\n    text-decoration: none;\n    cursor: pointer;\n    border-radius: 4px;\n    will-change: color, transform;\n    outline-offset: 3px;\n    transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;\n\n    &.primary-button {\n      outline-color: black;\n      border: none;\n      // background-color: var(--primary);\n      //Accessibility color contrast\n      background-color: #8c1c16;\n      color: white;\n      &:active {\n        transform: scale(0.95);\n      }\n\n      &:hover {\n        background-color: #c52820;\n      }\n\n      &:disabled {\n        background-color: var(--background-grey);\n        border-color: var(--outline-grey);\n        color: var(--outline-grey);\n      }\n    }\n    &.secondary-button {\n      color: var(--border-grey);\n      padding-top: 6px;\n      padding-bottom: 6px;\n      outline-offset: 4px;\n      border: 1px solid var(--border-grey);\n      text-decoration: none;\n\n      &:active {\n        transform: scale(0.95);\n      }\n\n      &:visited {\n        color: var(--border-grey);\n      }\n\n      &:hover {\n        color: var(--primary);\n      }\n\n      &:disabled {\n        background-color: var(--background-grey);\n        border-color: var(--outline-grey);\n        color: var(--outline-grey);\n        transform: none;\n      }\n    }\n\n    &.button-small {\n      padding: 2px 24px;\n    }\n  }\n}\n","@import '../mediaQueries.less';\n\n// These helpers are designed to replicate Product's 12-column design system.\n\n@columnGap: 16px;\n\n.calc-column-width(@columnCount, @totalColumns: 12) {\n  @combinedLayoutGaps: (@totalColumns - 1) * @columnGap;\n  @combinedElementGaps: (@columnCount - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedLayoutGaps}) / @{totalColumns}';\n\n  width: calc(@columnCount * @singleColumnWidth + @combinedElementGaps);\n}\n\n// Centered content contained by a 'full width' parent (in LF layout, this is actually 2/3 screen)\n//\n// @columns - the width of the content in terms of number of grid columns at the largest screen size\n.main-content-width-rules(@columns) {\n  // For small screens, the content spans all of the available columns\n  margin: 0 auto;\n  max-width: 792px;\n\n  @media @landscapeTabletUp {\n    // For medium screens, the allocated columns are 50% higher.\n    // So a container spanning 6 columns on desktop spans 9 on tablet.\n    @responsiveColumns: round(@columns * 1.5);\n    .calc-column-width(@responsiveColumns);\n  }\n\n  @media @desktopUp {\n    .calc-column-width(@columns);\n  }\n}\n\n// Guard clause for case where @mediumDesktopParentColumns param is defined; see below documentaiton\n.nested-input-width-rules(@parentColumns, @mediumDesktopParentColumns: 0)\n  when\n  (\n    @mediumDesktopParentColumns > 0\n  ) {\n  @combinedParentGaps: (@mediumDesktopParentColumns - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedParentGaps}) / @{mediumDesktopParentColumns}';\n  @media @mediumDesktopUp {\n    width: calc(100% - 2 * @singleColumnWidth);\n  }\n}\n\n// Centered content that is a child of a 'main-width' container as declared above.\n//\n// @parentColumns - the number of columns allocated to the container\n// @mediumDesktopPatentColumns - optional, the number of columns allocated to the container at\n//   medium-desktop breakpoints and up\n.nested-input-width-rules(@parentColumns, @mediumDesktopParentColumns: 0) {\n  // full width on small screens\n  width: 100%;\n  margin: 0 auto;\n\n  // drop 2 'columns' from the main-content parent width on larger screens\n\n  @responsiveColumns: @parentColumns;\n  @combinedParentGaps: (@responsiveColumns - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedParentGaps}) / @{responsiveColumns}';\n\n  @media @landscapeTabletUp {\n    // see @responsiveColumns note above\n    @responsiveColumns: round(@parentColumns * 1.5);\n    width: calc(100% - (2 * @singleColumnWidth));\n  }\n\n  @media @desktopUp {\n    width: calc(100% - (2 * @singleColumnWidth));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
